const style = {
  bulkEditPaper: {
    width: 750,
  },

  emailTag: {
    background: "#ffc617",
  },
  webhookTag: {
    background: "#ffa30a",
  },
  smsTag: {
    background: "#ffa30a",
  },
  glipTag: {
    background: "#f50",
  },
  statusColumn: {
    width: "54px",
    minWidth: "16px !important",
  },

  emptyLogoDiv: {
    background: "rgb(249, 249, 249)",
    border: "1px solid rgb(220, 221, 225)",
    height: 36,
    width: 124,
  },
  pageHeadingWrapper: {
    margin: "24px 0 40px 48px",
    position: "relative",
  },
  pageHeading: {
    color: "black",
    fontSize: 24,
    // fontFamily: theme.font.medium,
    fontWeight: 500,
    letterSpacing: 0.08,
  },
  pageHeadingCaption: {
    color: "grey.400",
    // fontFamily: theme.font.regular,
    fontSize: 12,
    letterSpacing: 0.17,
  },
  pageHeadingMarker: {
    background: "#7f5bdb",
    height: 70,
    width: 4,
    position: "absolute",
    left: -24,
    top: 0,
  },
  actionsWrapper: {
    display: "flex",
    alignItems: "center",
    padding: "8px 15px 24px 43px",
    borderBottom: `1px solid gray`,
  },
  actionBtnsLeft: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    "& > .action": {
      marginRight: 34,
      position: "relative",
      fontSize: 13,
      // fontFamily: theme.font.regular,
    },
  },
  actionBtnsRight: {
    display: "flex",
    alignItems: "center",
    "& > .action": {
      marginLeft: 2,
    },
  },
  tablePaper: {
    "border-radius": "10px",
    "max-height": "600px !important",
  },
};

export default style;
